// eslint-disable-next-line import/no-restricted-paths
import { processIncomingMobilityRoutes } from '../../unused/pages/client/incomingMobility/processIncomingMobility/routes';

import { clientCryptoAccountRoute } from './ClientCryptoAccountPage/route';
import { clientDetailRoute } from './ClientDetailPage/route';
import { clientEventsNewRoute } from './ClientEventsNewPage/route';
import { clientEventsRoute } from './ClientEventsPage/route';
import { clientMarketingActionsRoute } from './ClientMarketingActionsPage/route';
import { clientOverviewRoute } from './ClientOverviewPage/route';
import { verifyIdentityRoute } from './VerifyIdentityPage/route';
import { accountTerminationRoutes } from './accountTermination/routes';
import { clientApplicationsRoutes } from './applications/routes';
import { clientBankIdentityRoutes } from './clientBankIdentity/routes';
import { clientDocumentsRoutes } from './documents/routes';
import { createIncomingMobilityRoutes } from './incomingMobility/createIncomingMobility/routes';
import { nebankaOldRoute } from './nebanka/oldRoute';
import { nebankaRoutes } from './nebanka/routes';
import { clientProductsRoutes } from './products/routes';
import { clientRequirementsRoutes } from './requirements/routes';
import { clientRoute } from './route';
import { clientTransactionsRoutes } from './transactions/routes';

export const clientRoutes = clientRoute.addChildren([
	accountTerminationRoutes,
	clientApplicationsRoutes,
	clientBankIdentityRoutes,
	clientCryptoAccountRoute,
	clientDetailRoute,
	clientDocumentsRoutes,
	clientEventsRoute,
	clientEventsNewRoute,
	clientMarketingActionsRoute,
	clientOverviewRoute,
	verifyIdentityRoute,
	clientProductsRoutes,
	clientTransactionsRoutes,
	clientRequirementsRoutes,
	createIncomingMobilityRoutes,
	processIncomingMobilityRoutes,
	nebankaRoutes,
	nebankaOldRoute,
]);
